const getCloudGraphData = {
  variable: [
    '$condition: MetricsCondition!',
    '$duration: Duration!',
    '$type: InstanceType!',
    '$valueColumn: String',
  ],
  query: `
    readAllMetricsAtServiceScope: readAllMetricsAtServiceScope(
        condition: $condition,
        duration: $duration, type: $type, valueColumn: $valueColumn) {
        label
        values {
          values {id value}
        }
    }
        `,
};

const getCloudGraphDataV2 = {
  variable: [
    '$condition: MetricsCondition!',
    '$duration: Duration!',
    '$valueColumn: String',
    '$properties: [KeyValuePair!]!',
  ],
  query: `
  readAllMetricsAtServiceScopeV2: readAllMetricsAtServiceScopeV2(
        condition: $condition,
        duration: $duration, valueColumn: $valueColumn, properties: $properties) {
        label
        values {
          values {id value}
        }
        avg 
        max
    }
        `,
};
const getServiceForTeam = {
  variable: [
    '$duration: Duration!',
    '$serviceReq:ServiceReq!',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeam(duration: $duration, serviceReq:$serviceReq, permissions: $permissions) {
      key: id
      label: name
      permissions
    }
  `,
};

const getServiceForTeamByDuration = {
  variable: ['$serviceReq:ServiceReq!', '$duration: Duration!'],
  query: `
          services: getServiceForTeamByDuration(serviceReq:$serviceReq, duration: $duration) {
            key: id
            label: name
          }
        `,
};

const getServiceInstances = {
  variable: '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair]',
  query: `
  instanceId: getServiceInstances(duration: $duration, serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    instanceType
}
  `
};

const listDistinctPropertyValues = {
  variable: [
    '$teamId: String!',
    '$serviceId: ID!',
    '$duration: Duration!',
    '$propertyName: String!',
    '$properties: [KeyValuePair!]!',
  ],
  query: `
          listDistinctPropertyValues: listDistinctServiceInstanceMetaPropertyValues(teamId: $teamId, serviceId: $serviceId, duration: $duration, propertyName: $propertyName, properties: $properties)
        `,
};

const getTopAlertsPerService = {
  variable: [
    '$duration: Duration!',
    '$condition: TopAlertsPerServiceCondition!',
  ],
  query: `
  getTopAlertsPerService(duration: $duration,condition: $condition) {\n      alertsApps {    \n              serviceName,\n              count,\n              serviceId,\n              capability\n         }\n     }\n
  `,
};

const getTopAlertsPerInstances = {
  variable: ['$duration: Duration!', '$condition: TopAlertingCondition!'],
  query:
    'getTopMetricsByAlerts(duration: $duration, condition: $condition) { values { alertCount metricName } }',
};

const getServiceMetricsAggregation = {
  variable: ['$condition: MetricsCondition!', '$duration: Duration!'],
  query:
    'getServiceMetricsAggregation:getServiceMetricsAggregation(condition: $condition, duration: $duration) { avg sum }',
};

const getServiceMetricsAggregationByList = {
  variable: ['$condition: ServiceMetricsCondition!', '$duration: Duration!'],
  query:
    'getServiceMetricsAggregationByList(condition: $condition, duration: $duration) {\n    subscriptionId\n    values {\n      sum\n      avg\n      metricName\n    instanceCount\n    }\n  }',
};

const getInstanceMetricsAggregationList = {
  variable: [
    '$condition: MetricsCondition!',
    '$duration: Duration!',
    '$metricList: [String!]!',
  ],
  query:
    'readMetricsValueList(condition: $condition, duration: $duration, metricList: $metricList) {label \n value}',
};

const getMetricValueByServiceId = {
  variable: ['$condition: MetricsCondition!', '$duration: Duration!'],
  query:
    'getMetricValueByServiceId(condition: $condition, duration: $duration) { instanceName value }',
};

const getServiceMetricsValuesAggregation = {
  variable: [
    '$condition: ServiceMetricValuesCondition!',
    '$duration: Duration!',
  ],
  query: 'getServiceMetricsValuesAggregationByList(condition: $condition, duration: $duration) { serviceId metricValues { count total avg values { values { value } } } }',
};

const getLambdaFunctionsLogs = {
  variable: [
    '$condition: LambdaFunctionLogRequest!',
    '$duration: Duration!',
    '$pagination: Pagination!',
  ],
  query: ' getLambdaFunctionsLogs(condition: $condition, duration: $duration, pagination: $pagination) { logs { timestamp requestId duration initDuration memoryUsage isError eventSource } total }',
};

export const getCloudServiceInstances = {
  variable: '$serviceId: ID!, $duration: Duration!',
  query: `
    instanceId: getServiceInstances(duration: $duration, serviceId: $serviceId) {
      key: id
      label: name
      metaProperty1
      metaProperty2
      instanceType
    }
  `
};

export default {
  getCloudGraphData,
  getCloudGraphDataV2,
  getServiceForTeam,
  listDistinctPropertyValues,
  getTopAlertsPerService,
  getTopAlertsPerInstances,
  getServiceForTeamByDuration,
  getServiceMetricsAggregation,
  getServiceMetricsAggregationByList,
  getInstanceMetricsAggregationList,
  getMetricValueByServiceId,
  getServiceMetricsValuesAggregation,
  getLambdaFunctionsLogs,
  getCloudServiceInstances,
  getServiceInstances
};
